import React, { useEffect, useState } from "react";
import {
  getModules,
  getTokenInfo,
  getUserCountries,
} from "../../services/auth";
import PageContainer from "../../containers/PageContainer";
import CompanyWarning from "../../containers/CompanyWarning";
import ModuleCard from "../../components/ModuleCard";
import { getRedemptionCode } from "../../services/getRedemptionCode";
import { QRCodeCanvas } from "qrcode.react";
import { Modal, Button } from "antd";

import {
  Container,
  BannerContainer,
  CardContainer,
  Cards,
  BannerContent,
  PhoneIcon,
  AppleIcon,
  QRModalContent,
} from "./styles";

type Modules = {
  id: number;
  image: string;
  name: string;
  description: string;
  url: string;
  sort: number;
};

const Home: React.FC = () => {
  const [modulesList, setModulesList] = useState<Modules[]>([]);
  const [userMagicLing, setUserMagicLink] = useState<string>();
  const [userMagicLinkTemplate, setUserMagicLinkTemplate] = useState<string>();

  const [redeemUrl, setRedeemUrl] = useState<string | null>(null);
  const [redeemError, setRedeemError] = useState<string | null>(null);
  const [redeemLoading, setRedeemLoading] = useState(false);
  const [modalAndroidVisible, setModalAndroidVisible] = useState(false);
  const [modalIOSVisible, setModalIOSVisible] = useState(false);

  useEffect(() => {
    const init = () => {
      const user = getTokenInfo();
      const _modules = getModules();
      const countries = getUserCountries();

      _modules.sort((a, b) => a.sort - b.sort);
      setUserMagicLink(user?.magic_link_twygo);
      setUserMagicLinkTemplate(user?.magic_link_template_track);

      if (
        countries?.some((country) => country === "paraguai") ||
        (user && user?.level <= 1)
      ) {
        if (
          countries?.some((country) => country === "brasil") ||
          (user && user?.level <= 1)
        ) {
          setModulesList(_modules);
        } else {
          const _gestorBrasilModuleRemove = _modules.filter(
            (_module) => _module.name !== "Gestor de Vendas"
          );
          setModulesList(_gestorBrasilModuleRemove);
        }
      } else {
        const _gestorParaguaiModuleRemove = _modules.filter(
          (_module) => _module.name !== "Gestor de Vendas - Paraguai"
        );
        setModulesList(_gestorParaguaiModuleRemove);
      }
    };

    init();
  }, []);

  const userMagicLingPath = userMagicLing
    ? userMagicLing.split("universidade.franqueadosthebest.com")[1]
    : "";

  const userMagicLinkTemplatePath = userMagicLinkTemplate
    ? userMagicLinkTemplate.split("https://www.templatetrack.com")[1]
    : "";

  const handleRedeem = async () => {
    setRedeemLoading(true);
    setRedeemError(null);
    const user = getTokenInfo();

    const response = await getRedemptionCode(user?.id!!);
    if (response.error) setRedeemError(response.error);
    else if (response.url) setRedeemUrl(response.url);

    setRedeemLoading(false);
  };

  return (
    <PageContainer route="Página Inicial">
      <Container>
        <BannerContainer>
          <BannerContent>
            <h2>APLICATIVO DO FRANQUEADO</h2>
            <h1>THE BEST PORTAL</h1>
            <p>Acesse todas as funcionalidades no seu celular</p>

            <div className="buttons">
              <Button
                onClick={() => setModalAndroidVisible(true)}
                className="btn-android"
                icon={<PhoneIcon />}
              >
                Baixe para Android
              </Button>

              <Button
                onClick={() => setModalIOSVisible(true)}
                className="btn-ios"
                icon={<AppleIcon />}
              >
                Baixe para iOS
              </Button>
            </div>
          </BannerContent>
        </BannerContainer>

        <CardContainer>
          <Cards>
            {modulesList.map((modules) => (
              <ModuleCard
                _module={modules}
                key={modules.id}
                url_twygo={userMagicLingPath}
                url_template={userMagicLinkTemplatePath}
              />
            ))}
          </Cards>
        </CardContainer>
      </Container>

      <CompanyWarning />

      <Modal
        title="Download para Android"
        visible={modalAndroidVisible}
        onCancel={() => setModalAndroidVisible(false)}
        footer={null}
        centered
      >
        <QRModalContent>
          <p>
            Escaneie o QR code abaixo para baixar o aplicativo na Google Play
            Store
          </p>
          <div className="qr-wrapper">
            <QRCodeCanvas
              value="https://play.google.com/store/apps/details?id=com.amatech.amatechfranchiseeapp&pcampaignid=web_share"
              size={200}
            />
          </div>
          <p className="qr-link">
            Ou acesse diretamente pelo link:{" "}
            <a
              href="https://play.google.com/store/apps/details?id=com.amatech.amatechfranchiseeapp&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Play Store
            </a>
          </p>
        </QRModalContent>
      </Modal>

      <Modal
        title="Download para iOS"
        visible={modalIOSVisible}
        onCancel={() => setModalIOSVisible(false)}
        footer={null}
        centered
      >
        <QRModalContent>
          {!redeemUrl ? (
            <>
              <p>Resgate seu código único para baixar o app via App Store.</p>
              <div className="btn-wrapper">
                <Button
                  loading={redeemLoading}
                  onClick={handleRedeem}
                  className="btn-modal-ios"
                >
                  {redeemLoading ? "Resgatando..." : "Resgatar código iOS"}
                </Button>
              </div>
              <span>{redeemError}</span>
            </>
          ) : (
            <>
              <p>Escaneie o QR code abaixo para baixar o app:</p>
              <div className="qr-wrapper">
                <QRCodeCanvas value={redeemUrl} size={200} />
              </div>
              <p className="qr-link">
                Ou acesse diretamente pelo link:{" "}
                <a href={redeemUrl} target="_blank" rel="noopener noreferrer">
                  App Store
                </a>
              </p>
            </>
          )}
        </QRModalContent>
      </Modal>
    </PageContainer>
  );
};

export default Home;
